<template>
    <v-card>
        <v-card-title style="height: 55px">
            Review Rental Rates
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('modal-close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <div class="p-2" style="height: calc( 90vh - 55px);overflow-y:auto">
            <v-alert
                text
                color="info"
            >
                <div>This page lists all our prices, to select one you need to create new or edit existing renter on
                    current page.
                </div>
            </v-alert>

            <v-simple-table class="table-rental-rates bordered">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left">
                            <div>EQUIPMENT PACKAGE</div>
                        </th>
                        <template v-if="config.module_type_enabled != 0 && config.module_type == 'module_14'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day'}}</div>
                            </th>
                            <th class="text-left" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                2-3 Days
                            </th>
                            <th :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                4+ Days
                            </th>
                        </template>
                        <template v-else-if="$store.state.model.reservation.is_delivery">
                            <th :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Delivery
                            </th>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_11'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1st Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                2nd Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                3rd Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Additional Day Rate
                            </th>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.plaines'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Daily rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Multi day rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Weekly rate
                            </th>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.mtshastasports'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                3+ Day Rate
                            </th>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_16'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                3-4 Day
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                5+ Days
                            </th>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.nmsportsystems'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 to 2 Day'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                3 to 4 Day
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                               5 to 6 Day
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                7+ Days
                            </th>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.skigd'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Daily Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="$store.state.model.reservation.single_day_type=='afternoon'">
                                Afternoon
                            </th>
                            <th class="text-center" :style="priceThStyle" v-else>
                               Night
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Multi day rates
                            </th>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_17'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Daily Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="$store.state.model.reservation.single_day_type=='afternoon'">
                                Afternoon
                            </th>
                            <th class="text-center" :style="priceThStyle" v-else>
                               Night
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Multi day rates
                            </th>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.basin' || (config.module_type_enabled != 0 && (config.module_type == 'module_5' || config.module_type == 'module_8'))">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                3 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                4 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                5 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                6 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate">
                                7 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate&& frontend_view_folder == 'frontend.winterpark'">
                                8 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate&& frontend_view_folder == 'frontend.winterpark'">
                                9 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8')">
                                Additional Day Rate
                            </th>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_1'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                3 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Additional Day Rate
                            </th>
                        </template>
                        <template v-else-if="(config.module_type_enabled != 0 && config.module_type == 'module_5_1')">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                3 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                4 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                5 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                6 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                7 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Additional Day Rate
                            </th>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_2'">
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                1/2 Day Rate
                            </th>
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                3 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                4 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                5 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                6 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate">
                                7 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8')">
                                Additional Day Rate
                            </th>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_3'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Daily rate'}}</div>
                            </th>
                            <th :style="priceThStyle" v-if="config.multi_day_is_enabled && !$store.state.model.reservation.is_seasonal && !$store.state.model.reservation.is_prepay=='1'">
                                <div>{{multi_day_title}}</div>
                            </th>
                            <th class="text-left" :style="priceThStyle" v-if="config.discount > 0 && !$store.state.model.reservation.is_prepay=='1'">
                                <div>Online Rate ({{ config.discount }}% Discount)</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                1/2 Day Rate
                            </th>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.rootsrentals' || frontend_view_folder == 'frontend.stowe' || (config.module_type_enabled != 0 && config.module_type == 'module_4')">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                2 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                3 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                4 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                5 Day Rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Additional Day Rate
                            </th>
                        </template>
                        <template v-else-if="config.module_type_enabled && config.module_type=='module_9'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                               Day 2 to 3 rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                               Day 4+ rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal && $store.state.model.reservation._type=='kiosk' ">
                                1/2 Day rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Night rate
                            </th>
                        </template>
                        <template v-else-if="config.module_type_enabled && config.module_type=='module_10'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : '1 Day Rate'}}</div>
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                               Day 2 rate
                            </th>
                            <th class="text-center" :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Additional day rate
                            </th>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.gallatin' || frontend_view_folder == 'frontend.tygart' || (config.module_type_enabled != 0 && config.module_type == 'module_3')">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Day 1 to 2 rate'}}</div>
                            </th>
                            <th :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Day 3 to 4 rate
                            </th>
                            <th :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                               Day 5 + rate
                            </th>
                        </template>
                        <template v-else-if="frontend_view_folder == 'frontend.ridesnow'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Mid-Week Rate (M-TH)'}}</div>
                            </th>
                            <th :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                               Weekend / Holiday Rate
                            </th>
                        </template>
                        <template v-else-if="config.module_type_enabled != 0 && (config.module_type == 'module_6' || config.module_type == 'module_18')">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Mid-Week Rate (M-TH)'}}</div>
                            </th>
                            <th :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                               Weekend / Holiday Rate
                            </th>
                            <th :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                               Night Skiing
                            </th>
                        </template>
                         <template v-else-if="config.module_type_enabled && config.module_type=='module_13'">
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Day 1 to 2 rate'}}</div>
                            </th>
                            <th :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                                Day 2 to 5 rate
                            </th>
                            <th :style="priceThStyle" v-if="!$store.state.model.reservation.is_seasonal">
                              Day 6+ rate
                            </th>
                        </template>
                        <template v-else>
                            <th class="text-left" :style="priceThStyle">
                                <div>{{ $store.state.model.reservation.is_seasonal ? 'Seasonal rate' : 'Daily rate'}}</div>
                            </th>
                            <th :style="priceThStyle" v-if="config.multi_day_is_enabled && !$store.state.model.reservation.is_seasonal && !$store.state.model.reservation.is_prepay=='1'">
                                <div>{{multi_day_title}}</div>
                            </th>
                            <th class="text-left" :style="priceThStyle" v-if="config.discount > 0 && !$store.state.model.reservation.is_prepay=='1'">
                                <div>Online Rate ({{ config.discount }}% Discount)</div>
                            </th>
                        </template>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="group in packages_list_data">
                        <template v-if="(group.title !== 'Group reservations') || (group.title === 'Group reservations' && config.group_reservation == 1)">
                            <tr>
                                <td :colspan="colspan">
                                    <h4>{{ group.title }}</h4>
                                </td>
                            </tr>
                            <tr v-for="item in group.items">
                                <td>
                                    <v-expansion-panels v-if="item.description" flat tile>
                                        <v-expansion-panel v-model="packagesExpansion[item.id]"
                                                        style="background: transparent" expand>
                                            <v-expansion-panel-header>
                                                {{ item.title }}
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content ripple >
                                                <div v-html="item.description"></div>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                    <span v-else>{{ item.title }}</span>
                                </td>
                                <template v-if="config.module_type_enabled != 0 && config.module_type == 'module_14'">
                                    <td class="text-right">{{ item.current_rate }}</td>
                                    <td class="text-right" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day2_rate }}</td>
                                    <td class="text-right" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_4_plus }}</td>
                                </template>
                                <template v-else-if="$store.state.model.reservation.is_delivery">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_11'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_2_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_3_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.additional_day_rate }}</td>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.plaines'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.multi_day_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_7_rate }}</td>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.mtshastasports'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_2_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_3_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_16'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day2_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day3_4_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_5_rate }}</td>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.basin' || (config.module_type_enabled != 0 && (config.module_type == 'module_5' || config.module_type == 'module_8'))">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_2_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_3_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_4_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_5_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_6_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate">{{ item.day_7_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate && frontend_view_folder == 'frontend.winterpark'">{{ item.day_8_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate && frontend_view_folder == 'frontend.winterpark'">{{ item.day_9_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8')">{{ item.additional_day_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_1'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_2_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_3_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.additional_day_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_2'">
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.half_day_rate }}</td>
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_2_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_3_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_4_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_5_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_6_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal && showSevenDayRate">{{ item.day_7_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal && (config.module_type_enabled != 0 && config.module_type !== 'module_8')">{{ item.additional_day_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_5_3'">
                                    <td class="text-right">{{ item.daily_rate }}</td>
                                    <td class="text-right" v-if="config.multi_day_is_enabled && !$store.state.model.reservation.is_seasonal && !$store.state.model.reservation.is_prepay=='1'">{{ item.multi_day_rate }}</td>
                                    <td class="text-right" v-if="config.discount > 0 && !$store.state.model.reservation.is_prepay=='1'">{{ item.online_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.half_day_rate }}</td>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.rootsrentals' || frontend_view_folder == 'frontend.stowe' || (config.module_type_enabled != 0 && config.module_type == 'module_4')">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_2_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_3_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_4_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_5_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.additional_day_rate }}</td>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.nmsportsystems'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day3_4_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day5_6_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_7_plus }}</td>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.skigd'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="$store.state.model.reservation.single_day_type=='afternoon'">{{ item.half_day_rate }}</td>
                                    <td class="text-center" v-else>{{ item.night_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.multi_day_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled != 0 && config.module_type == 'module_17'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="$store.state.model.reservation.single_day_type=='afternoon'">{{ item.half_day_rate }}</td>
                                    <td class="text-center" v-else>{{ item.night_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.multi_day_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled && config.module_type=='module_9'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day2_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_4_plus }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal  && $store.state.model.reservation._type=='kiosk' ">{{ item.half_day_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.night_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled && config.module_type=='module_10'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day2_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.additional_day_rate }}</td>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.gallatin' || frontend_view_folder == 'frontend.tygart' || (config.module_type_enabled !=0 && config.module_type == 'module_3') ">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day3_4_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_4_plus }}</td>
                                </template>
                                <template v-else-if="frontend_view_folder == 'frontend.ridesnow'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.holiday_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled !=0 && (config.module_type == 'module_6' || config.module_type == 'module_18')">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.holiday_rate }}</td>
                                <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.night_rate }}</td>
                                </template>
                                <template v-else-if="config.module_type_enabled && config.module_type=='module_13'">
                                    <td class="text-center">{{ item.current_rate }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day2_5 }}</td>
                                    <td class="text-center" v-if="!$store.state.model.reservation.is_seasonal">{{ item.day_6_plus }}</td>
                                </template>
                                <template v-else>
                                    <td class="text-right">{{ item.daily_rate }}</td>
                                    <td class="text-right" v-if="config.multi_day_is_enabled && !$store.state.model.reservation.is_seasonal && !$store.state.model.reservation.is_prepay=='1'">{{ item.multi_day_rate }}</td>
                                    <td class="text-right" v-if="config.discount > 0 && !$store.state.model.reservation.is_prepay=='1'">{{ item.online_rate }}</td>
                                </template>
                            </tr>
                        </template>
                    </template>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </v-card>

</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "RentalRates",
    data: () => ({
        packagesExpansion: [],
        colspan: 12,
    }),
    computed: {
        ...mapGetters(['packages_list_data']),
        priceColumnWidth() {
            return 140;
        },
        priceThStyle() {
            return {
                'max-width': this.priceColumnWidth + 'px',
                width: this.priceColumnWidth + 'px'
            }
        },
        config(){
            console.log(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type=='module_6');
            return this.$store.state.resources.config;
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
        multi_day_title() {
            return (parseInt(this.$store.state.resources.config.multi_day_start_after) + 1) + " and more days Rate";
        },
        showSevenDayRate() {
            return window.location.hostname !== 'rentals.alpenhausonline.com';
        }
    },
    mounted() {
        this.$store.state.resources.packages.forEach(p =>
            this.packagesExpansion[p.id] = false
        );
        if(this.$store.state.resources.config.module_type_enabled != 0 && (this.$store.state.resources.config.module_type == 'module_5_1' || this.$store.state.resources.config.module_type == 'module_9')){
            this.colspan = 5;
        }
        if(this.$store.state.resources.config.module_type_enabled != 0 && this.$store.state.resources.config.module_type == 'module_9' && this.$store.state.model.reservation._type == 'kiosk'){
            this.colspan = 6;
        }
    }
}
</script>

<style scoped>
.bordered table{
    border: thin solid rgba(0, 0, 0, 0.12);
}

.table-rental-rates th {
    font-size: 0.9rem !important;
    white-space: normal;
    vertical-align: middle;
}

.table-rental-rates td {
    vertical-align: middle;
}

.table-rental-rates th div {
    text-align: center;
}

.table-rental-rates .v-expansion-panel-header {
    padding: 0;
    margin: 0;
    font-size: 100%;
}

.table-rental-rates >>> .v-expansion-panel-content__wrap {
    padding-left: 0;
}
</style>
